import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy-950';
  const variants = {
    primary: 'bg-silver hover:bg-silver-light text-navy-950 focus:ring-silver shadow-[0_4px_14px_0_rgba(201,212,228,0.3)] hover:shadow-[0_6px_20px_rgba(201,212,228,0.45)] hover:-translate-y-0.5',
    secondary: 'bg-navy-700 hover:bg-navy-600 text-silver-light focus:ring-silver shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    outline: 'border-2 border-silver/60 hover:border-silver text-silver-light hover:bg-navy-800/60 focus:ring-silver'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-331" data-mp="12lsbb7t0w3mw">
      {children}
      {withArrow && <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-332" data-mp="1cd50tsrcmhpr" />}
    </motion.button>;
}